import { T } from "../../app/tokens.js";
import { budgetHealth, milestoneSignal } from "../../lib/projectDisplaySignals.js";
import { formatRecordAmount } from "./projectRecord.js";

export const budgetHealthColor = health => health.state === "over" ? T.red : health.state === "near" ? T.amberDark : health.state === "not_tracked" ? T.mid : T.dark;

export function budgetHealthText(health, currency = "USD") {
  return health.overage != null
    ? `${health.label} · +${formatRecordAmount(health.overage, currency)} over`
    : health.label;
}

export function BudgetHealthLabel({ budget, forecast, currency = "USD" }) {
  const health = budgetHealth(budget, forecast);
  return <span data-budget-health={health.state} style={{ color: budgetHealthColor(health), fontSize: T.fsXs }}>{budgetHealthText(health, currency)}</span>;
}

export function MilestoneSignal({ milestone, timeZone, now }) {
  const signal = milestoneSignal(milestone, timeZone, now);
  if (signal.reason?.startsWith("Project time zone")) return <span title={signal.reason} style={{ color: T.mid, fontSize: T.fsXxs }}> · Overdue status unknown (time zone unavailable)</span>;
  if (!signal.overdue) return null;
  return <span data-milestone-overdue="true" style={{ display: "inline-flex", alignItems: "center", gap: 4, color: T.red, fontSize: T.fsXxs, whiteSpace: "nowrap" }}>
    <span style={{ background: T.redSoft, color: T.red, borderRadius: 5, padding: "0 5px", fontWeight: T.fwBold }}>Overdue</span>
    <span>{signal.days} days overdue</span>
  </span>;
}
